export const FETCH_BESTSELLER_MATCHES_INIT = 'FETCH_BESTSELLER_MATCHES_INIT';
export const FETCH_BESTSELLER_MATCHES_SUCCESS = 'FETCH_BESTSELLER_MATCHES_SUCCESS';
export const FETCH_BESTSELLER_MATCHES_FAIL = 'FETCH_BESTSELLER_MATCHES_FAIL';
export const FETCH_BESTSELLER_MATCHES_IS_ALREADY = 'FETCH_BESTSELLER_MATCHES_IS_ALREADY';

export const FETCH_LIVE_BETTING_POPULAR_INIT = 'FETCH_LIVE_BETTING_POPULAR_INIT';
export const FETCH_LIVE_BETTING_POPULAR_SUCCESS = 'FETCH_LIVE_BETTING_POPULAR_SUCCESS';
export const SET_ODDS_COMPARISON = 'FETCH_LIVE_BETTING_ODDS_ARRAY';
export const FETCH_LIVE_BETTING_POPULAR_FAIL = 'FETCH_LIVE_BETTING_POPULAR_FAIL';
export const FETCH_LIVE_BETTING_POPULAR_IS_ALREADY = 'FETCH_LIVE_BETTING_POPULAR_IS_ALREADY';

export const FETCH_HOT_BANNERS_INIT = 'FETCH_HOT_BANNERS_INIT';
export const FETCH_HOT_BANNERS_SUCCESS = 'FETCH_HOT_BANNERS_SUCCESS';
export const FETCH_HOT_BANNERS_FAIL = 'FETCH_HOT_BANNERS_FAIL';

export const FETCH_BANNERS_INIT = 'FETCH_BANNERS_INIT';
export const FETCH_BANNERS_SUCCESS = 'FETCH_BANNERS_SUCCESS';
export const FETCH_BANNERS_FAIL = 'FETCH_BANNERS_FAIL';
export const FETCH_BANNERS_READY = 'FETCH_BANNERS_READY';

export const FETCH_REGISTRATION_BANNERS_INIT = 'FETCH_REGISTRATION_BANNERS_INIT';
export const FETCH_REGISTRATION_BANNERS_SUCCESS = 'FETCH_REGISTRATION_BANNERS_SUCCESS';
export const FETCH_REGISTRATION_BANNERS_FAIL = 'FETCH_REGISTRATION_BANNERS_FAIL';

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGIN_INIT = 'LOGIN_INIT';
export const LOGOUT = 'LOGOUT';
export const BACKGROUND_LOGIN_STATUS = 'BACKGROUND_LOGIN_STATUS';
export const UPDATE_BREADCRUMBS = 'UPDATE_BREADCRUMBS';
export const APP_THEME = 'APP_THEME';
export const BALANCE_DATA = 'BALANCE_DATA';

export const USER_VERIFICATION_STATUS_SUCCESS = 'USER_VERIFICATION_STATUS_SUCCESS';
export const USER_VERIFICATION_STATUS_FAIL = 'USER_VERIFICATION_STATUS_FAIL';
export const USER_VERIFICATION_STATUS_INIT = 'USER_VERIFICATION_STATUS_INIT';

//BETS API
export const ADD_BET = 'ADD_BET';
// export const CALCULATE_TAX = 'CALCULATE_TAX';
export const CALCULATE_TAX_SUCCESS = 'CALCULATE_TAX_SUCCESS';
export const CALCULATE_TAX_INIT = 'CALCULATE_TAX_INIT';
export const CALCULATE_TAX_FAIL = 'CALCULATE_TAX_FAIL';

export const REMOVE_FREE_BET_STACK = 'REMOVE_FREE_BET_STACK';

export const CHANGE_BET_OUTCOMES_INIT = 'CHANGE_BET_OUTCOMES_INIT';
export const CHANGE_BET_OUTCOMES_SUCCESS = 'CHANGE_BET_OUTCOMES_SUCCESS';

export const ANALYTICS_REMOVE_BET = 'ANALYTICS_REMOVE_BET';
export const ANALYTICS_REPLACE_BET = 'ANALYTICS_REPLACE_BET';
export const ANALYTICS_ENABLE_BET = 'ANALYTICS_ENABLE_BET';
export const ANALYTICS_DISABLE_BET = 'ANALYTICS_DISABLE_BET';
export const ANALYTICS_CLEAR_BETS = 'ANALYTICS_CLEAR_BETS';
export const UPDATE_BETS_STAKE = 'UPDATE_BETS_STAKE';
export const UPDATE_USER_DETAILS = 'UPDATE_USER_DETAILS';
export const CHANGE_BET_MODE = 'CHANGE_BET_MODE';

// live data
export const SET_LIVE_EVENT = 'SET_LIVE_EVENT';
export const SET_ACTIVE_SPORT = 'SET_ACTIVE_SPORT';
export const FETCH_ALL_LIVE_EVENTS = 'FETCH_ALL_LIVE_EVENTS';

//sport data
export const FETCH_CATEGORIES_FLAGS = 'FETCH_CATEGORIES_FLAGS';

// placement data
export const FETCH_PLACEMENTS = 'FETCH_PLACEMENTS';

// cpPanelData
export const FETCH_MESSAGES_SUCCESS = 'FETCH_MESSAGES_SUCCESS';
export const FETCH_MESSAGES_INIT = 'FETCH_MESSAGES_INIT';
export const FETCH_MESSAGES_FAIL = 'FETCH_MESSAGES_FAIL';

// cpPanelDataMessagesList
export const FETCH_MESSAGES_LIST_SUCCESS = 'FETCH_MESSAGES_LIST_SUCCESS';
export const FETCH_MESSAGES_LIST_INIT = 'FETCH_MESSAGES_LIST_INIT';
export const FETCH_MESSAGES_LIST_FAIL = 'FETCH_MESSAGES_LIST_FAIL';
export const SET_MESSAGES_COUNT_SUCCESS = 'SET_MESSAGES_COUNT_SUCCESS';

//breadcrumb
export const SET_SPORT_BREADCRUMB = 'SET_SPORT_BREADCRUMB';
export const SET_SEEMORE_COUNT_SPORT = 'SET_SEEMORE_COUNT_SPORT';
export const SET_SEEMORE_COUNT_SPORT_CATEGORY = 'SET_SEEMORE_COUNT_SPORT_CATEGORY';

export const UNREAD_MESSAGE_SUCCESS = 'UNREAD_MESSAGE_SUCCESS';

// categories data
export const FETCH_CATEGORIES = 'FETCH_CATEGORIES';
export const FETCH_POPULAR_CATEGORIES = 'FETCH_POPULAR_CATEGORIES';

// cookies
export const SHOW_COOKIE = 'SHOW_COOKIE';

// livechat
export const LIVE_CHAT = 'LIVE_CHAT';

// vip
export const VIP = 'VIP';

// won coupon confetti
export const WIN_DATA = 'WIN_DATA';

//login modals state modal
export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';
export const SHOW_REMIND_MODAL = 'SHOW_REMIND_MODAL';
export const HIDE_REMIND_MODAL = 'HIDE_REMIND_MODAL';

export const SHOW_VERIFICATION_MODAL = 'SHOW_VERIFICATION_MODAL';
export const HIDE_VERIFICATION_MODAL = 'HIDE_VERIFICATION_MODAL';

//register modal state modal
export const SHOW_REGISTER_MODAL = 'SHOW_REGISTER_MODAL';
export const HIDE_REGISTER_MODAL = 'HIDE_REGISTER_MODAL';
export const SHOW_REGISTER_MODAL_STEP2 = 'SHOW_REGISTER_MODAL_STEP2';
export const HIDE_REGISTER_MODAL_STEP2 = 'HIDE_REGISTER_MODAL_STEP2';

//sport prematch event details
export const FETCH_EVENT_DETAIL_DATA_SUCCESS = 'FETCH_EVENT_DETAIL_DATA_SUCCESS';
export const RESET_EVENT_DETAIL_DATA = 'RESET_EVENT_DETAIL_DATA';

//event live details
export const FETCH_EVENT_LIVE_DATA_SUCCESS = 'FETCH_EVENT_LIVE_DATA_SUCCESS';
export const RESET_EVENT_LIVE_DATA = 'RESET_EVENT_LIVE_DATA';

//promotion name
export const FETCH_PROMOTION_NAME_SUCCESS = 'FETCH_PROMOTION_NAME_SUCCESS';

//arrow for breadcrumb
export const SET_ARROW_STATE = 'SET_ARROW_STATE';

//sport event image
export const FETCH_SPORT_EVENT_IMAGE = 'FETCH_SPORT_EVENT_IMAGE';

//fetch statscore id
export const FETCH_STATSCORE_ID = 'FETCH_STATSCORE_ID';

// cpCoupons in-game count
export const IN_GAME_COUPON_COUNT = 'IN_GAME_COUPON_COUNT';

// layout set error
export const LAYOUT_ERROR_PLACEHOLDER = 'LAYOUT_ERROR_PLACEHOLDER';

export const UPDATE_STAKE_VALUES = 'UPDATE_STAKE_VALUES';

//Player profile
export const SET_AVATAR = 'SET_AVATAR';
export const PLAYER_STATS = 'PLAYER_STATS';
export const OPEN_DRAWER = 'OPEN_DRAWER';
export const CLOSE_DRAWER = 'CLOSE_DRAWER';
export const FETCH_MEDALS_SUCCESS = 'FETCH_MEDALS_SUCCESS';
export const FETCH_MEDALS_FAILURE = 'FETCH_MEDALS_FAILURE';
export const FETCH_MEDALS_INIT = 'FETCH_MEDALS_INIT';
export const LAST_DEPOSIT_METHOD = 'LAST_DEPOSIT_METHOD';
export const SET_COLLAPSED_MARKET = 'SET_COLLAPSED_MARKET';

// modal
export const MODAL_OPEN = 'MODAL_OPEN';
export const MODAL_CLOSE = 'MODAL_CLOSE';
export const SET_MODAL_CONTENT = 'SET_MODAL_CONTENT';

//primary coupon overview panel
export const SET_PRIMARY_OVERVIEW_PANEL_VISIBLE = 'SET_PRIMARY_OVERVIEW_PANEL_VISIBLE';
